import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Command } from '@workbuddy/ui/model';
import { AlertSeverity } from '@workbuddy/ui/components/alert';

@Injectable({ providedIn: 'root' })
export class ToastService {

    private readonly messageService = inject(MessageService);

    constructor() { }

    public success(summary?: string, detail?: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity: 'success',
                actions,
            },
        });
    }

    public error(summary?: string, detail?: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity: 'danger',
                actions
            },
        });
    }

    public info(summary?: string, detail?: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity: 'info',
                actions
            },
        });
    }

    public warning(summary?: string, detail?: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity: 'warning',
                actions
            },
        });
    }

    public neutral(summary?: string, detail?: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity: 'neutral',
                actions,
            },
        });
    }

    public primary(summary?: string, detail?: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity: 'primary',
                actions,
            },
        });
    }

    public show(severity: AlertSeverity, summary: string, detail: string, actions?: Command[]) {
        this.messageService.add({
            summary,
            detail,
            data: {
                severity,
                actions,
            },
        });
    }

    public clearAll() {
        this.messageService.clear();
    }

}